import axios from 'axios'
import util from './util'
import router from "../../router"
import { getOtmLoteUrl, getAlgoritmoHost } from "@/main.js"

/**
 * Build request object according to request
 * type.
 * 
 * @param {Object} dataObject 
 * @param {String} requestType 
 * 
 * @returns {Object}
 */
const buildRequestObject = function(dataObject, requestType){
    let requestObject = {
        requestType,
        $token: util.getLocalVar('backoffice_token'),
        currentUserCode: util.getLocalVar("userData") && util.getLocalVar("userData").CDOPERADOR
    };

    requestObject[requestType.toLowerCase()] = dataObject;

    return requestObject;
}

const _getBaseUriPrefix = function() {
    const {protocol, hostname, port} = document.location;
    let ret;
    if(process.env.VUE_APP_BASE_URI_PREFIX === "false"){
        ret = `${protocol}//${hostname}${port && ':' + port}`;
    } else {
        ret = process.env.VUE_APP_BASE_URI_PREFIX;
    }
    return ret;
};

const onInvalidToken = () => {
    console.error('Invalid Token!');
    localStorage.removeItem('backoffice_token');

    const {CDOPERADOR} = JSON.parse(localStorage.getItem('userData'));
    const boData = util.getFilterInSession();
    const {CDFILIAL, NMFILIAL, CDSERVFILI, NMSERVICO, TPCONTRATO, NMCONTRATO, DTMESCARD} = JSON.parse(boData);

    localStorage.removeItem('userData');
    sessionStorage.removeItem('filterData');
    localStorage.removeItem('backOfficeData');
    localStorage.removeItem('permissions');
    localStorage.removeItem('canAccessPermissionManagement');
    sessionStorage.setItem('oldFilterData',
        JSON.stringify({CDFILIAL, NMFILIAL, CDSERVFILI, NMSERVICO, TPCONTRATO, NMCONTRATO, DTMESCARD, CDOPERADOR})
    );
    router.push('/');
};

export default {
    baseUriPrefix : _getBaseUriPrefix(),
    baseUri : process.env.VUE_APP_BASE_URI,
    // baseUriPrefixOtmBatch: OTM_LOTE_URL,
    postRequest: function(url, dataObject = {}, requestType = "Row", timeout = 1200000, extraOptions = {}){
        if(url === 'caloptServer'){
            dataObject.url = getAlgoritmoHost();
        }
        const requestOptions = {
            responseType: 'json',
            ...extraOptions
        }
        return axios({
            method:'post',
            url: this.baseUriPrefix+'/'+this.baseUri+'/'+url,
            data: buildRequestObject(dataObject, requestType),
            timeout,
            ...requestOptions
        })
        .then(successResponse => {
            if(successResponse.headers.backofficent){
                //console.log("refreshed");
                util.setLocalVar('backoffice_token', successResponse.headers.backofficent);
                const permissions = JSON.parse(unescape(successResponse.headers.backofficepr));
                permissions.scopes = permissions.scopes.map(s => parseInt(s));
                util.setLocalVar('permissions', permissions);
            }
            return successResponse && successResponse.data || successResponse;
        })
        .catch(axiosResponse => {
            const {error} = axiosResponse.response.data;
            const hasToken = localStorage.getItem('backoffice_token') !== null;
            if(error && (error.includes('FORBIDDEN_ACCESS') || error.includes('INVALID_TOKEN')) && hasToken){
                onInvalidToken();
            } else {
                throw error;
            }
        });
    },

    postRequestOtmNode: function(endPoint, data){
        data.$token = util.getLocalVar('backoffice_token');
        return axios({
            method:'post',
            url: `${getOtmLoteUrl()}/${endPoint}`,
            data
        });
    },
}